import React from 'react';
import UsageTableRow from '../usage-table-row';
import {COLOR_PALETTE} from '../Color/constants';
import styles from './usage-table.module.scss';

class UsageTable extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.shadeThead}>Shade</th>
              <th>HEX</th>
              <th>Variable</th>
              <th>Typical Usage</th>
              <th className={styles.contrastRatioThead}>Contrast Ratio*</th>
            </tr>
          </thead>
          <tbody>
            {COLOR_PALETTE.map((color) => (
              <UsageTableRow key={`${color.name}-row`} color={color} />
            ))}
          </tbody>
        </table>
        <p className={styles.tableNote}>
          *Contrast Ratio only refers to the color against a white background.<br></br>4.5 is the
          minimum contrast ratio needed for accessibility.
        </p>
      </div>
    );
  }
}

export default UsageTable;
